import axios from './config';

const demoRequestLeadServices = {};

demoRequestLeadServices.createOrResume = async (body = {}) => {
  const { data } = await axios.post('/demo_request_leads', { demo_request_lead: body, public_token: body.public_token });
  return data;
};

demoRequestLeadServices.update = async (publicToken, body = {}) => {
  const { data } = await axios.patch(`/demo_request_leads/${publicToken}`, { demo_request_lead: body });
  return data;
};

demoRequestLeadServices.complete = async (publicToken, body = {}) => {
  const { data } = await axios.post(`/demo_request_leads/${publicToken}/complete`, { demo_request_lead: body });
  return data;
};

export default demoRequestLeadServices;
